import { render, staticRenderFns } from "./ProductProcessCreateEdit.vue?vue&type=template&id=c591d406&scoped=true&"
import script from "./ProductProcessCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ProductProcessCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c591d406",
  null
  
)

export default component.exports